import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface DisconnectClientDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  clientName: string;
}

const DisconnectClientDialog = ({
  open,
  onOpenChange,
  onConfirm,
  clientName
}: DisconnectClientDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-600">
            <AlertTriangle className="h-5 w-5" />
            Disconnect from Client
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to disconnect from {clientName}? This action will:
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Remove your access to their journal entries</li>
              <li>Hide their activity status from your dashboard</li>
              <li>Remove them from your active client list</li>
            </ul>
            <p className="mt-2 text-sm text-amber-600">
              This action can be reversed later if needed.
            </p>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2 sm:gap-0">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
          >
            Disconnect
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DisconnectClientDialog; 